import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

import {RegressionOutput} from 'shared/dtos/cockpit-kontrolle/einfluss-von-extremwerten-m1';

@Component({
  selector: '[appRegressionOutputTableRow]',
  templateUrl: './regression-output-table-row.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class RegressionOutputTableRowComponent
  extends CurrentLocaleComponent
  implements OnInit
{
  @Input() data: RegressionOutput;
  @Input() columns: string[];
  @Input() key: string;
  @Input() headerItalic = false;

  constructor(protected readonly translate: TranslateService) {
    super(translate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
